import routes from "../common/api-routes";
import {HttpAuthGet, HttpAuthPost, HttpAuthPutParams, HttpAuthPutPayload, HttpAuthPostParams} from "../../../../core/services/common/HttpRequestBuilder";

const getListPortWithPagination = (parameters) => {
    let result = HttpAuthGet(routes.GET_LIST_PORT_WITH_PAGINATION, parameters);
    return result;
}

const viewPort = (parameters) => {
    let result = HttpAuthGet(routes.VIEW_PORT, parameters);
    return result;
}

const createPort = (payload) => {
    let result = HttpAuthPost(routes.CREATE_PORT, payload);
    return result;
}

const searchPort = (port_name) => {
    let query_params = {
        port_name
    }
    let result = HttpAuthPostParams(routes.SEARCH_PORT, query_params);
    return result;
}

const getPortTypeList = () => {
    let result = HttpAuthGet(routes.GET_PORT_TYPE_LIST);
    return result;
}

const updatePort = (payload) => {
    let result = HttpAuthPutPayload(routes.UPDATE_PORT, payload);
    return result;
}

const updatePortStatus = (parameters) => {
    let result = HttpAuthPutParams(routes.UPDATE_PORT_STATUS, parameters);
    return result;
}

const filterPort = (parameters) => {
    let result = HttpAuthGet(routes.FILTER_PORT, parameters);
    return result;
}


const PortService = {
    getListPortWithPagination: getListPortWithPagination,
    viewPort: viewPort,
    createPort: createPort,
    searchPort,
    getPortTypeList: getPortTypeList,
    updatePort: updatePort,
    updatePortStatus: updatePortStatus,
    filterPort: filterPort
}

export default PortService